import { persistReducer } from "redux-persist";
import storage from "redux-persist/es/storage";
import { takeRight } from "lodash";

import { SET_SEARCH_TERM_INITIAL } from "./constants";

const initialState = {
  terms: [],
};

function lastSearches(state = initialState, action) {
  switch (action.type) {
    case SET_SEARCH_TERM_INITIAL:
      return {
        ...state,
        terms: !action.payload ? state.terms || [] : takeRight((state.terms || []).filter((st) => st && st !== action.payload).concat([action.payload]), 5),
      };

    default:
      return state;
  }
}

const persistConfigConfig = {
  key: "z-catalog-last-searches",
  storage: storage,
  debug: false,
  whitelist: ["terms"],
};

export default persistReducer(persistConfigConfig, lastSearches);
